export const CREATING_TRACKING_DEVICE_ASSIGNMENT = 'Creating Tracking Device Assignment';
export const RETRIEVING_TRACKING_DEVICE_ASSIGNMENTS = 'Retrieving Tracking Device Assignments';
